import {
  Alert,
  Button,
  Card,
  Checkbox,
  Col,
  Input,
  Modal,
  Radio,
  Row,
  Space,
  Tag,
} from "antd";
import React, { useState } from "react";
import { BiCheck, BiSolidErrorCircle } from "react-icons/bi";
import "./Modals.css";
import { router } from "../../../engine/router/AppRouter";
import { colorPrimary } from "../../../root";
import { ExclamationCircleFilled } from "@ant-design/icons";
import {
  daysJsFormat,
  languagesList,
  renderBeneficiary,
  renderUserName,
  roles,
  statusPrestations,
} from "../../../utils/constants";
import DownloadICS from "../DownloadICS/DownloadICS";
import { storeNew } from "../../../store/store.new";
import { Provider } from "react-redux";
import { PrestationCancel } from "./PrestationCancel";
import { InstitutionNewAddress } from "./InstitutionNewAddress";
import { FaCalendarAlt, FaCheckCircle, FaUserPlus } from "react-icons/fa";
import dayjs from "../../../utils/dayjs";
import routes from "../../../engine/routes";
import Title from "antd/es/typography/Title";
import { t } from "i18next";
import { BillCamtLinking } from "./BillCamtLinking";
import { onlyRoleMapping } from "../../../engine/AuthRoute";

const sharedProps = {
  okButtonProps: {
    style: { backgroundColor: "var(--color-primary)", borderRadius: 2 },
    className: "ok-modal-button",
    size: "large",
  },
  cancelButtonProps: {
    size: "large",
    style: { borderRadius: 2 },
    className: "cancel-modal-button",
  },
};

export const defaultProps = {
  open: true,
  cancelText: "Annuler",
  okButtonProps: sharedProps.okButtonProps,
  cancelButtonProps: sharedProps.cancelButtonProps,
};

export const modalsByContext = {
  PrestationCancel: "PrestationCancel",
  BillCamtLinking: "BillCamtLinking",
  PrestationFollow: "PrestationFollow",
  PrestationEditAdmin: "PrestationEditAdmin",
  InstitutionNewAddress: "InstitutionNewAddress",
  InstitutionSelectAddress: "InstitutionSelectAddress",
  PrestationControl: "PrestationControl",
  PrestationGrouped: "PrestationGrouped",
  SelectResponsable: "SelectResponsable",
  UsersDuplicator: "UsersDuplicator",
};

export const confirmBillsCamt = async ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: t("camt.titleModal"),
    content: (
      <div>
        <p dangerouslySetInnerHTML={{ __html: t("camt.content") }} />
      </div>
    ),
    open: true,
    okText: t("camt.confirm"),
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: async () => onOk(),
    onCancel: async () => onCancel(),
  });

export const confirmValidateDraftPrestation = async ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: t("confirmValidateDraftPrestation.title"),
    content: (
      <div>
        <h4>{t("confirmValidateDraftPrestation.content1")}</h4>
        <p>{t("confirmValidateDraftPrestation.content2")}</p>
      </div>
    ),
    open: true,
    okText: t("confirmValidateDraftPrestation.okText"),
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: async () => onOk(),
    onCancel: async () => onCancel(),
  });
export const confirmManuelPrestation = async ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: t("confirmManuelPrestation.title"),
    content: (
      <div>
        <h4>{t("confirmManuelPrestation.content1")}</h4>
        <p>{t("confirmManuelPrestation.content2")}</p>
        <p>{t("confirmManuelPrestation.content3")}</p>
      </div>
    ),
    open: true,
    okText: t("confirmManuelPrestation.okText"),
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: async () => onOk(),
    onCancel: async () => onCancel(),
  });

const RenderPrestatioNSame = ({ s, stat, lng, benef }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <a
      style={{
        color: isHovered ? "red" : "black",
        display: "block",
        marginBottom: 5,
      }}
      href={routes.prestations(s._id).detail.path}
      target={"_blank"}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Tag size={"middle"} color={stat.color}>
        {stat.label()}
      </Tag>{" "}
      - {dayjs(s.finalStartDate).format(daysJsFormat.hour)} -{" "}
      {dayjs(s.finalEndDate).format(daysJsFormat.hour)}
      {s?.interprete ? " - " + renderUserName(s?.interprete) : ""}{" "}
      {lng ? ` - ${lng}` : ""}
      <Tag color={"red"} size={"large"}>
        {s.reference}
      </Tag>
      {benef !== null ? "| " + benef : ""}
    </a>
  );
};

export const prestationAlreadyExist = async ({
  onOk = () => {},
  onCancel = () => {},
  content = {},
}) =>
  Modal.confirm({
    width: 600,
    title: t("prestationAlreadyExist.title"),
    content: (
      <div>
        <p>{t("prestationAlreadyExist.content1")}</p>
        <span>
          {t("prestationAlreadyExist.similarPrestations")}:
          <br />
          <br />
          {content.prestations.map(s => {
            let stat = statusPrestations().find(a => a.value === s.status);
            let lng = languagesList().find(c => c.value === s.languages[0])
              ?.label;

            return (
              <>
                <RenderPrestatioNSame
                  stat={stat}
                  s={s}
                  lng={lng}
                  benef={
                    content.isAdmin ? renderBeneficiary(s?.beneficiary) : null
                  }
                />
              </>
            );
          })}
        </span>
      </div>
    ),
    open: true,
    okText: t("prestationAlreadyExist.okText"),
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: async () => onOk(),
    onCancel: async () => onCancel(),
  });

export const newPrestationSelectors = async ({
  onOk = () => {},
  onCancel = () => {},
  content,
}) => {
  return Modal.info({
    width: 820,
    icon: null,
    title: null,
    maskClosable: true,
    closable: true,
    content: (
      <>
        <div>
          <Title level={2} style={{ textAlign: "center" }}>
            {t("newPrestationSelectors.title")}
          </Title>
        </div>
        <br />
        <Row gutter={[10, 10]}>
          <Col sm={24} md={12}>
            <Card
              style={{
                backgroundColor: "#f3f3f3",
              }}
              title={
                <Title level={4} style={{ textAlign: "center", marginTop: 20 }}>
                  {t("newPrestationSelectors.createByDateTitle")}
                </Title>
              }
              bodyStyle={{
                paddingTop: 5,
              }}
            >
              <p style={{ textAlign: "center" }}>
                {t("newPrestationSelectors.createByDateContent")}
              </p>
              <Button
                {...sharedProps.okButtonProps}
                type={"primary"}
                className={"confirmButton  extraSizeButton"}
                onClick={() => {
                  content.navigate(routes.prestations("new").new.path, {
                    replace: true,
                  });
                  Modal.destroyAll();
                }}
              >
                <Space direction={"horizontal"}>
                  <FaCalendarAlt size={20} style={{ marginTop: -5 }} />
                  {t("newPrestationSelectors.searchByDateButton")}
                </Space>
              </Button>
            </Card>
          </Col>

          <Col sm={24} md={12}>
            <Card
              style={{
                backgroundColor: "#f3f3f3",
              }}
              title={
                <Title level={4} style={{ textAlign: "center", marginTop: 20 }}>
                  {t("newPrestationSelectors.createByInterpreterTitle")}
                </Title>
              }
              bodyStyle={{
                paddingTop: 5,
              }}
            >
              <p style={{ textAlign: "center" }}>
                {t("newPrestationSelectors.createByInterpreterContent")}
              </p>
              <Button
                {...sharedProps.okButtonProps}
                type={"primary"}
                className={"confirmButton  extraSizeButton"}
                onClick={() => {
                  content.navigate(routes.prestations("new").selector.path, {
                    replace: true,
                  });
                  Modal.destroyAll();
                }}
              >
                <Space direction={"horizontal"}>
                  <FaUserPlus size={22} style={{ marginTop: -5 }} />
                  {t("newPrestationSelectors.searchByInterpreterButton")}
                </Space>
              </Button>
            </Card>
          </Col>
        </Row>
      </>
    ),
    open: true,
    okButtonProps: {
      ...sharedProps.okButtonProps,
      style: {
        display: "none",
        ...sharedProps.okButtonProps.style,
      },
    },
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: async () => onOk(),
    onCancel: async () => onCancel(),
  });
};

export const manuelAttributeInterprete = async ({
  onOk = () => {},
  onCancel = () => {},
  content = {},
}) =>
  Modal.confirm({
    title: t("manuelAttributeInterprete.title"),
    content: (
      <div>
        <p>{t("manuelAttributeInterprete.content1")}</p>
        <span>
          {t("manuelAttributeInterprete.concerns")}:{" "}
          <b>{renderUserName(content.record.interprete)}</b>
        </span>
      </div>
    ),
    open: true,
    okText: t("manuelAttributeInterprete.okText"),
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: async () => onOk(),
    onCancel: async () => onCancel(),
  });

export const confirmRelanceInterpreteInvitation = async ({
  onOk = () => {},
  onCancel = () => {},
  content = {},
}) =>
  Modal.confirm({
    title: t("confirmRelanceInterpreteInvitation.title"),
    content: (
      <div>
        <p>
          {t("confirmRelanceInterpreteInvitation.content1", {
            user: renderUserName(content?.user),
          })}
        </p>
      </div>
    ),
    open: true,
    okText: t("confirmRelanceInterpreteInvitation.okText"),
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: async () => onOk(),
    onCancel: async () => onCancel(),
  });

export const confirmDirectInterpreteInvitation = async ({
  onOk = () => {},
  onCancel = () => {},
  content = {},
}) =>
  Modal.confirm({
    title: t("confirmDirectInterpreteInvitation.title"),
    content: (
      <div>
        <p>
          {t("confirmDirectInterpreteInvitation.content1", {
            user: renderUserName(content?.user),
          })}
        </p>
      </div>
    ),
    open: true,
    okText: t("confirmDirectInterpreteInvitation.okText"),
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: async () => onOk(),
    onCancel: async () => onCancel(),
  });

export const modalAnswerPrestationInvitation = async ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: t("modalAnswerPrestationInvitation.title"),
    content: <div>{t("modalAnswerPrestationInvitation.content1")}</div>,
    open: true,
    okText: t("modalAnswerPrestationInvitation.okText"),
    cancelText: t("modalAnswerPrestationInvitation.cancelText"),
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: async () => onOk(),
    onCancel: async () => onCancel(),
  });

export const modalModificationPrestationPending = ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: t("modalModificationPrestationPending.title"),
    content: (
      <div>
        <h4>{t("modalModificationPrestationPending.content1")}</h4>
        <p>{t("modalModificationPrestationPending.content2")}</p>
        <p>{t("modalModificationPrestationPending.content3")}</p>
      </div>
    ),
    open: true,
    okText: t("modalModificationPrestationPending.okText"),
    cancelText: t("modalModificationPrestationPending.cancelText"),
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: () => onOk(),
    onCancel: () => onCancel(),
  });

export const modalConfirmDeleteBill = ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: t("modalConfirmDeleteBill.title"),
    content: (
      <div>
        <h4>{t("modalConfirmDeleteBill.content1")}</h4>
        <p>{t("modalConfirmDeleteBill.content2")}</p>
      </div>
    ),
    open: true,
    okText: t("modalConfirmDeleteBill.okText"),
    cancelText: t("modalConfirmDeleteBill.cancelText"),
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: () => onOk(),
    onCancel: () => onCancel(),
  });

export const modalModificationPrestationFinishPending = ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: t("modalModificationPrestationFinishPending.title"),
    content: (
      <div>
        <h4>{t("modalModificationPrestationFinishPending.content1")}</h4>
        <p>{t("modalModificationPrestationFinishPending.content2")}</p>
      </div>
    ),
    open: true,
    okText: t("modalModificationPrestationFinishPending.okText"),
    cancelText: t("modalModificationPrestationFinishPending.cancelText"),
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: () => onOk(),
    onCancel: () => onCancel(),
  });

export const interpreteAcceptModification = ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: t("interpreteAcceptModification.title"),
    content: (
      <div>
        <h4>{t("interpreteAcceptModification.content1")}</h4>
      </div>
    ),
    open: true,
    okText: t("interpreteAcceptModification.okText"),
    cancelText: t("interpreteAcceptModification.cancelText"),
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: () => onOk(),
    onCancel: () => onCancel(),
  });

export const confirmDeletebatch = ({ onOk = () => {}, onCancel = () => {} }) =>
  Modal.confirm({
    title: t("confirmDeletebatch.title"),
    content: (
      <div>
        <h4>{t("confirmDeletebatch.content1")}</h4>
      </div>
    ),
    open: true,
    okText: t("confirmDeletebatch.okText"),
    cancelText: t("confirmDeletebatch.cancelText"),
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: () => onOk(),
    onCancel: () => onCancel(),
  });

export const interpreteRefuseModification = ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: t("interpreteRefuseModification.title"),
    content: (
      <div>
        <h4>{t("interpreteRefuseModification.content1")}</h4>
        <p>{t("interpreteRefuseModification.content2")}</p>
      </div>
    ),
    open: true,
    okText: t("interpreteRefuseModification.okText"),
    cancelText: t("interpreteRefuseModification.cancelText"),
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: () => onOk(),
    onCancel: () => onCancel(),
  });

export const userIntervenantDuplicate = ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: t("userIntervenantDuplicate.title"),
    content: (
      <div>
        <h4>{t("userIntervenantDuplicate.content1")}</h4>
        <p>{t("userIntervenantDuplicate.content2")}</p>
      </div>
    ),
    open: true,
    okText: t("userIntervenantDuplicate.okText"),
    cancelText: t("userIntervenantDuplicate.cancelText"),
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: () => onOk(),
    onCancel: () => onCancel(),
  });

export const userIntervenantDuplicateLink = ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: t("userIntervenantDuplicateLink.title"),
    content: (
      <div>
        <h4>{t("userIntervenantDuplicateLink.content1")}</h4>
        <p>{t("userIntervenantDuplicateLink.content2")}</p>
      </div>
    ),
    open: true,
    okText: t("userIntervenantDuplicateLink.okText"),
    cancelText: t("userIntervenantDuplicateLink.cancelText"),
    okButtonProps: sharedProps.okButtonProps,
    cancelButtonProps: sharedProps.cancelButtonProps,
    onOk: () => onOk(),
    onCancel: () => onCancel(),
  });

export const confirmAnswerYesPrestation = async ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    width: "60%",
    icon: null,
    content: (
      <div className={"center-full"}>
        <div className={"confirmYes"}>
          <div className={"checkBig"}>
            <BiCheck color={colorPrimary} size={60} />
          </div>
          <h3>{t("confirmAnswerYesPrestation.content1")}</h3>

          <p>{t("confirmAnswerYesPrestation.content2")}</p>
          <Row style={{ width: "100%" }}>
            <Col md={12} xs={24}>
              <Provider store={storeNew}>
                <DownloadICS type={"button"} />
              </Provider>
            </Col>
            <Col md={12} xs={24}>
              <Button
                size={"large"}
                className={"confirmButton forceNormal"}
                onClick={() => {
                  router.navigate("/", { replace: true });
                  Modal.destroyAll();
                }}
              >
                {t("routes.back")}
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    ),
    footer: null,
    okText: t("confirmAnswerYesPrestation.okText"),
    cancelText: t("confirmAnswerYesPrestation.cancelText"),
    ...defaultProps,
    onOk: async () => onOk(),
    onCancel: async () => {
      router.navigate("/", { replace: true });
      Modal.destroyAll();
    },
  });

export const prestationsFinishSuccess = ({
  onOk = () => {},
  onCancel = () => {},
  user,
}) =>
  Modal.confirm({
    title: <h2>{t("prestationsFinishSuccess.title")}</h2>,
    content: (
      <div className={"confirmYes"}>
        <div className={"checkBig"} style={{ textAlign: "center" }}>
          <BiCheck color={colorPrimary} size={60} />
        </div>

        <p>{t("prestationsFinishSuccess.content1")}</p>
      </div>
    ),
    icon: null,
    ...defaultProps,
    okText: t("prestationsFinishSuccess.okText"),
    cancelText: t("prestationsFinishSuccess.cancelText"),
    onOk,
    onCancel,
  });

export const confirmDeletePrestation = ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: t("confirmDeletePrestation.title"),
    content: (
      <div>
        <h4>{t("confirmDeletePrestation.content1")}</h4>
        <p>{t("confirmDeletePrestation.content2")}</p>
      </div>
    ),
    ...defaultProps,
    okText: t("confirmDeletePrestation.okText"),
    onOk,
    onCancel,
  });

export const confirmDeleteInstitution = ({
  onOk = () => {},
  onCancel = () => {},
  props,
}) => {
  const validIcon = <FaCheckCircle color={"green"} size={18} />;
  const errorIcon = <BiSolidErrorCircle color={"red"} size={20} />;

  return Modal.confirm({
    title: t("confirmDeleteInstitution.title"),
    content: (
      <div>
        <h4>{t("confirmDeleteInstitution.content1")}</h4>
        <p>{t("confirmDeleteInstitution.content2")}</p>
        <p>{t("confirmDeleteInstitution.content3")}</p>

        <Alert
          size={"small"}
          icon={props.users.length > 0 ? errorIcon : validIcon}
          message={
            props.users.length > 0
              ? t("confirmDeleteInstitution.usersExist", {
                  count: props.users.length,
                })
              : t("confirmDeleteInstitution.noUsers")
          }
          type={props.users.length > 0 ? "error" : "success"}
          showIcon
        />

        <Alert
          size={"small"}
          icon={props.address.length > 0 ? errorIcon : validIcon}
          message={
            props.address.length > 0
              ? t("confirmDeleteInstitution.addressExist", {
                  count: props.address.length,
                })
              : t("confirmDeleteInstitution.noAddresses")
          }
          type={props.address.length > 0 ? "error" : "success"}
          showIcon
        />

        <Alert
          size={"small"}
          icon={props.sharedToInstitutions.length > 0 ? errorIcon : validIcon}
          message={
            props.sharedToInstitutions.length > 0
              ? t("confirmDeleteInstitution.sharedAddressExist", {
                  count: props.sharedToInstitutions.length,
                })
              : t("confirmDeleteInstitution.noSharedAddresses")
          }
          type={props.sharedToInstitutions.length > 0 ? "error" : "success"}
          showIcon
        />

        <Alert
          size={"small"}
          icon={props.principal !== null ? errorIcon : validIcon}
          message={
            props.principal !== null
              ? t("confirmDeleteInstitution.principalExists")
              : t("confirmDeleteInstitution.noPrincipal")
          }
          type={props.principal !== null ? "error" : "success"}
          showIcon
        />

        <Alert
          size={"small"}
          icon={props.prestations.length > 0 ? errorIcon : validIcon}
          message={
            props.prestations.length > 0
              ? t("confirmDeleteInstitution.prestationsExist", {
                  count: props.prestations.length,
                })
              : t("confirmDeleteInstitution.noPrestations")
          }
          description={
            props.prestations.length > 0 ? (
              <>
                {props.prestations.map(prestation => (
                  <Tag>
                    <a
                      href={routes.prestations(prestation._id).detail.path}
                      target={"_blank"}
                    >
                      {prestation.reference}
                    </a>
                  </Tag>
                ))}
              </>
            ) : (
              undefined
            )
          }
          type={props.prestations.length > 0 ? "error" : "success"}
          showIcon
        />

        <Alert
          size={"small"}
          icon={props.bills.length > 0 ? errorIcon : validIcon}
          message={
            props.bills.length > 0
              ? t("confirmDeleteInstitution.billsExist", {
                  count: props.bills.length,
                })
              : t("confirmDeleteInstitution.noBills")
          }
          description={
            props.bills.length > 0 ? (
              <>
                {props.bills.map(bill => (
                  <Tag>
                    <a
                      href={routes.billing(bill._id).detail.path}
                      target={"_blank"}
                    >
                      {bill.bill_number}
                    </a>
                  </Tag>
                ))}
              </>
            ) : (
              undefined
            )
          }
          type={props.bills.length > 0 ? "error" : "success"}
          showIcon
        />
      </div>
    ),
    width: 600,
    ...defaultProps,
    okButtonProps:
      props.bills.length === 0 &&
      props.prestations.length === 0 &&
      props.address.length === 0 &&
      props.principal === null &&
      props.users.length === 0
        ? defaultProps.okButtonProps
        : { size: "large", style: { borderRadius: 2 }, disabled: true },
    okText: t("confirmDeleteInstitution.okText"),
    onOk,
    onCancel,
  });
};

export const confirmDeleteUserInstitution = ({
  onOk = () => {},
  onCancel = () => {},
  props,
}) => {
  const validIcon = <FaCheckCircle color={"green"} size={18} />;
  const errorIcon = <BiSolidErrorCircle color={"red"} size={20} />;

  return Modal.confirm({
    title: t("confirmDeleteUserInstitution.title"),
    content: (
      <div>
        <h4>{t("confirmDeleteUserInstitution.content1")}</h4>

        <p>{t("confirmDeleteUserInstitution.content2")}</p>

        <Alert
          size={"small"}
          icon={props.prestations.length > 0 ? errorIcon : validIcon}
          message={
            props.prestations.length > 0
              ? t("confirmDeleteUserInstitution.prestationsExist", {
                  count: props.prestations.length,
                })
              : t("confirmDeleteUserInstitution.noPrestations")
          }
          description={
            props.prestations.length > 0 ? (
              <>
                {props.prestations.map(prestation => (
                  <Tag>
                    <a
                      href={routes.prestations(prestation._id).detail.path}
                      target={"_blank"}
                    >
                      {prestation.reference}
                    </a>
                  </Tag>
                ))}
              </>
            ) : (
              undefined
            )
          }
          type={props.prestations.length > 0 ? "error" : "success"}
          showIcon
        />
      </div>
    ),
    width: 600,
    ...defaultProps,
    okButtonProps:
      props.prestations.length === 0
        ? defaultProps.okButtonProps
        : { size: "large", style: { borderRadius: 2 }, disabled: true },
    okText: t("confirmDeleteUserInstitution.okText"),
    onOk,
    onCancel,
  });
};

export const confirmFinalUserDelete = ({
  onOk = () => {},
  onCancel = () => {},
  user,
}) => {
  return Modal.confirm({
    title: t("confirmFinalUserDelete.title"),
    content: (
      <div>
        <p>{t("confirmFinalUserDelete.content.text1")}</p>
        <b>{renderUserName(user)}</b>
      </div>
    ),
    ...defaultProps,
    okText: t("confirmFinalUserDelete.okText"),
    onOk,
    icon: <ExclamationCircleFilled style={{ color: "red" }} />,
    onCancel,
  });
};

export const confirmFinalInstitutionDelete = ({
  onOk = () => {},
  onCancel = () => {},
  institution,
}) => {
  return Modal.confirm({
    title: t("confirmFinalInstitutionDelete.title"),
    content: (
      <div>
        <p>{t("confirmFinalInstitutionDelete.content.text1")}</p>
        <b>{institution.name}</b>
      </div>
    ),
    ...defaultProps,
    okText: t("confirmFinalInstitutionDelete.okText"),
    onOk,
    icon: <ExclamationCircleFilled style={{ color: "red" }} />,
    onCancel,
  });
};

export const confirmFinishPrestation = ({
  onOk = () => {},
  onCancel = () => {},
}) =>
  Modal.confirm({
    title: t("confirmFinishPrestation.title"),
    width: 400,
    content: (
      <div>
        <p>{t("confirmFinishPrestation.content.text1")}</p>
        <p>{t("confirmFinishPrestation.content.text2")}</p>
        <p>{t("confirmFinishPrestation.content.text3")}</p>
        <p>{t("confirmFinishPrestation.content.text4")}</p>
      </div>
    ),
    ...defaultProps,
    okText: t("confirmFinishPrestation.okText"),
    onOk,
    onCancel,
  });

export const askNewSearchInterpretesPrestation = ({
  onOk = () => {},
  onCancel = () => {},
  date,
}) =>
  Modal.confirm({
    title: t("askNewSearchInterpretesPrestation.title"),
    width: 400,
    content: (
      <div>
        <p>{t("askNewSearchInterpretesPrestation.content.text1")}</p>
        <p>
          {t("askNewSearchInterpretesPrestation.content.text2")} <br />{" "}
          <b>{dayjs(date).format(daysJsFormat.full)}.</b>
        </p>
      </div>
    ),
    ...defaultProps,
    okText: t("askNewSearchInterpretesPrestation.okText"),
    onOk,
    onCancel,
  });

export const confirmCancelPrestation = ({
  onOk = () => {},
  onCancel = () => {},
  user,
}) =>
  Modal.confirm({
    width: "70%",
    title: t("confirmCancelPrestation.title"),
    content: (
      <div>
        <PrestationCancel />
        <p>{t("confirmCancelPrestation.content.text1")}</p>
        <h4>{t("confirmCancelPrestation.content.text2")}</h4>
        <Radio.Group>
          <Space
            direction="vertical"
            style={{ marginBottom: 10 }}
            size={"small"}
          >
            <Radio value={"institution"}>
              {t("confirmCancelPrestation.content.radioInstitution")}
            </Radio>
            <Radio value={"interprète"}>
              {t("confirmCancelPrestation.content.radioInterprete")}
            </Radio>
            <Radio value={"permanance"}>
              {t("confirmCancelPrestation.content.radioPermanance")}
            </Radio>
          </Space>
        </Radio.Group>
        <br />
        <label>
          <h4>{t("confirmCancelPrestation.content.text3")}</h4>
          <Input.TextArea
            placeholder={t(
              "confirmCancelPrestation.content.textareaPlaceholder",
            )}
            rows={4}
          />
        </label>
        <br />
        <br />
        <h4>{t("confirmCancelPrestation.content.text4")}</h4>

        <Checkbox.Group className={"customform-radio"}>
          <Space
            direction="vertical"
            style={{ marginBottom: 10 }}
            size={"small"}
          >
            <Checkbox value={"interprete"}>
              <Space direction="vertical">
                <span style={{ fontWeight: 700 }}>
                  {t("confirmCancelPrestation.content.checkboxInterprete")}
                </span>
              </Space>
            </Checkbox>
            <Checkbox value={"demandeur"}>
              <Space direction="vertical">
                <span style={{ fontWeight: 700 }}>
                  {t("confirmCancelPrestation.content.checkboxDemandeur")}
                </span>
              </Space>
            </Checkbox>
          </Space>
        </Checkbox.Group>
      </div>
    ),
    ...defaultProps,
    cancelText: t("confirmCancelPrestation.cancelText"),
    okText: t("confirmCancelPrestation.okText"),
    onOk,
    onCancel,
  });

export const confirmDuplicatePrestation = ({
  onOk = () => {},
  onCancel = () => {},
  user,
}) =>
  Modal.confirm({
    title: t("confirmDuplicatePrestation.title"),
    content: (
      <div>
        <p>{t("confirmDuplicatePrestation.content.text1")}</p>
      </div>
    ),
    ...defaultProps,
    okText: t("confirmDuplicatePrestation.okText"),
    onOk,
    onCancel,
  });

export const confirmUpdateRoutePrice = ({
  onOk = () => {},
  onCancel = () => {},
}) => {
  let modalRef;
  modalRef = Modal.confirm({
    title: t("confirmUpdateRoutePrice.title"),
    icon: <ExclamationCircleFilled style={{ color: "#faad14" }} />,
    closable: true,
    width: 480,
    content: (
      <div>
        <p>{t("confirmUpdateRoutePrice.content1")}</p>
        <p style={{ color: "#666", fontSize: 13 }}>
          {t("confirmUpdateRoutePrice.content2")}
        </p>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
            marginTop: 24,
          }}
        >
          <Button
            size="large"
            type="primary"
            block
            style={{
              backgroundColor: "var(--color-primary)",
              borderRadius: 2,
            }}
            onClick={() => {
              modalRef.destroy();
              onOk();
            }}
          >
            {t("confirmUpdateRoutePrice.okText")}
          </Button>
          <Button
            size="large"
            block
            style={{ borderRadius: 2 }}
            onClick={() => {
              modalRef.destroy();
              onCancel();
            }}
          >
            {t("confirmUpdateRoutePrice.cancelText")}
          </Button>
        </div>
      </div>
    ),
    okButtonProps: { style: { display: "none" } },
    cancelButtonProps: { style: { display: "none" } },
    onCancel: () => {},
  });
};
